import { AktenIdentifier } from "@dpa/common/dist";
import { trpc } from "../../App";

export function useFinanceData(identifier: AktenIdentifier) {
  return trpc.akte.financeData.useQuery(identifier)
}
